import IconView from "../IconView";


let FileIconView = IconView.createPlugin("File", {

    onOpen() {
        this.modal.show();
    }
});

export default FileIconView;
